
export class OrderResponse {
    error: boolean;
    message: string;
    data: any;
    partnerID: number;
    addOnProducts: number[];
    testToken: string;
  }
  